import Component from './BusinessDocumentsFormsListContainer';
export default Component;
